import { Link } from "react-router-dom";
import styles from "./Hero.module.css";

export function Hero() {
  return (
    <section className={styles.hero} aria-labelledby="hero-heading">
      <div className={`container-wide ${styles.grid}`}>
        <div className={styles.text} data-reveal>
          <p className={styles.kicker}>
            <span className={styles.kickerDot} aria-hidden="true" />
            Hermosa Beach &nbsp;/&nbsp; Hair Artist
          </p>
          <h1 id="hero-heading" className={styles.headline}>
            Beautiful hair,
            <br />
            <span className={styles.italic}>designed to live in.</span>
          </h1>
          <p className={styles.subhead}>
            Private studio specializing in dimensional color, lived-in blondes, and precision cuts —
            thoughtfully tailored to you and made to wear beautifully between appointments.
          </p>
          <div className={styles.actions}>
            <a href="/#book" className="btn btn--primary btn--lg">
              Book an appointment
              <span aria-hidden="true">{"\u2197"}</span>
            </a>
            <Link to="/services/dimensional-color" className="btn btn--secondary btn--lg">
              Explore signature work
            </Link>
          </div>
        </div>

        <figure className={styles.media} data-reveal>
          <picture>
            <source type="image/avif" srcSet="/assets/hero-520.avif 1x, /assets/hero-1040.avif 2x" />
            <source type="image/webp" srcSet="/assets/hero-520.webp 1x, /assets/hero-1040.webp 2x" />
            <img
              src="/assets/hero.jpg"
              width={1040}
              height={1300}
              alt="Editorial portrait in the Hermosa Beach studio"
              loading="eager"
              fetchPriority="high"
              decoding="sync"
            />
          </picture>
        </figure>
      </div>
    </section>
  );
}
